import { createRouter, createWebHashHistory } from "vue-router";

import Home from "@/pages/home";
import Puzzle from "@/pages/puzzle";
import Card from "@/pages/card";
import Loading from "@/pages/loading";

const { VUE_APP_TITLE } = process.env;

const routes = [
    {
        path: "/",
        name: "Loading",
        component: Loading
    },
    {
        path: "/home",
        name: "Home",
        component: Home,
        meta: {
            title: VUE_APP_TITLE
        }
    },
    {
        path: "/puzzle",
        name: "Puzzle",
        component: Puzzle,
        meta: {
            title: VUE_APP_TITLE
        }
    },
    {
        path: "/card",
        name: "Card",
        component: Card,
        meta: {
            title: VUE_APP_TITLE
        }
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

router.beforeEach((to, _, next) => {

    document.title = VUE_APP_TITLE;

    next();
});

export default router;